<div class="parent-container">
    <app-editable-text 
        [customClass]="'custom-title-large header-custom-class-text'" 
        [elemId]="subtitleId()" 
        role="presentation">
    </app-editable-text>

    <app-editable-text 
        [customClass]="'custom-headline-medium header-custom-class-text'" 
        [elemId]="titleId()" 
        role="heading"
        aria-level="2">
    </app-editable-text>
</div>